export function calcBookEv(fairOddsDecimal: number, bookOddsAmerican: number): number | null {
  if (fairOddsDecimal <= 0) return null;
  const fairProb = fairOddsDecimal < 1 ? fairOddsDecimal : 1 / fairOddsDecimal;
  if (fairProb <= 0 || fairProb >= 1) return null;
  const decimalOdds = bookOddsAmerican > 0
    ? bookOddsAmerican / 100 + 1
    : 100 / Math.abs(bookOddsAmerican) + 1;
  return (fairProb * decimalOdds - 1) * 100;
}
